import { Store } from "cobra-find-a-store/src/types";
import { useStaticQuery, graphql } from "gatsby";

export const getActiveIcon = (cashless: boolean) => {
  const google = typeof window !== "undefined" ? window.google : (null as any);

  return cashless
    ? {
        url: "https://image.e.cashmoney.ca/lib/fe2411747364047b731d77/m/1/9b853eab-e8de-4eb7-a211-65efc6d71af1.png",
        scaledSize: new google.maps.Size(52, 37),
        anchor: new google.maps.Point(25, 30),
      }
    : {
        url: "https://image.e.cashmoney.ca/lib/fe2411747364047b731d77/m/1/9db28249-cfb4-494c-9df2-f4feccdae1b0.png",
        scaledSize: new google.maps.Size(52, 27),
        anchor: new google.maps.Point(20, 8.25),
      };
};

export const getDefaultIcon = (cashless: boolean) => {
  return cashless
    ? {
        url: "https://image.e.cashmoney.ca/lib/fe2411747364047b731d77/m/1/9b853eab-e8de-4eb7-a211-65efc6d71af1.png",
        scaledSize: new google.maps.Size(32, 24),
      }
    : {
        url: "https://image.e.cashmoney.ca/lib/fe2411747364047b731d77/m/1/9db28249-cfb4-494c-9df2-f4feccdae1b0.png",
        anchor: new google.maps.Point(13, 6.25),
        scaledSize: new google.maps.Size(40, 20.5),
      };
};
